import type { FC } from "react";
import React, { memo } from "react";
import { useDetailedGrade, useGetCompareGrades } from "../../compareHooks";
import PackRow from "./PackRow";

const PacksSingle: FC = () => {
    const grades = useGetCompareGrades();
    const detailedGrade = useDetailedGrade(grades[0]);

    if (!detailedGrade) {
        return null;
    }

    return (
        <>
            {detailedGrade.packs.map((pack) => (
                <PackRow key={pack.id} packs={[pack, undefined]} />
            ))}
        </>
    );
};

export default memo(PacksSingle);
